export default __webpack_public_path__ + "static/media/ThaiSansNeue-Light.305ecfc9.otf";